import { useState } from 'react';
import { Share2, Maximize2, ZoomIn, X, ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './ui/button';
import { Dialog, DialogContent } from './ui/dialog';

interface ImageModalProps {
  images: string[];
  isOpen: boolean;
  onClose: () => void;
}

export function ImageModal({ images, isOpen, onClose }: ImageModalProps) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const next = (e: React.MouseEvent) => {
    e.stopPropagation();
    setCurrentIndex((prev) => {
      const newIndex = (prev + 1) % images.length;
      return newIndex;
    });
  };

  const previous = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent event propagation
    setCurrentIndex((prev) => {
      const newIndex = (prev - 1 + images.length) % images.length;
      return newIndex;
    });
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-[1112px] h-[80vh] p-0 bg-white/90">
        <div className="relative h-full flex items-center justify-center">
          {/* Counter and actions */}
          <div className="absolute top-4 left-4 right-4 flex justify-between items-center text-black z-50">
            <span className="text-sm text-black">
              {currentIndex + 1}/{images.length}
            </span>
            <div className="flex gap-4">
              <Button variant="ghost" size="icon" className="text-black hover:text-black/80">
                <Share2 className="h-5 w-5 text-black" />
              </Button>
              <Button variant="ghost" size="icon" className="text-black hover:text-black/80">
                <Maximize2 className="h-5 w-5 text-black" />
              </Button>
              <Button variant="ghost" size="icon" className="text-black hover:text-black/80">
                <ZoomIn className="h-5 w-5 text-black" />
              </Button>
              <Button variant="ghost" size="icon" className="text-black hover:text-black/80" onClick={onClose}>
                <X className="h-5 w-5 text-black" />
              </Button>
            </div>
          </div>

          {/* Image Container */}
          <div className="relative w-[800px] h-[60vh] flex items-center justify-center">
            {images.length > 0 && (
              <div className="w-full h-full flex items-center justify-center"> {/* Fixed width and height */}
                <img
                  key={currentIndex} // Force re-render by changing the key
                  src={images[currentIndex]}
                  alt={`${currentIndex + 1}`}
                  className="w-full h-full object-contain" // Ensure image fits within container
                />
              </div>
            )}
          </div>

          {/* Navigation buttons */}
          <Button
            variant="ghost"
            size="icon"
            className="absolute left-4 text-black hover:text-black/80 cursor-pointer"
            onClick={previous}
          >
            <ChevronLeft className="h-8 w-8" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            className="absolute right-4 text-white hover:text-black/80 bg-[#B87775] rounded-full cursor-pointer"
            onClick={next}
          >
            <ChevronRight className="h-8 w-8" />
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}